import FacebookLogin from "@greatsumini/react-facebook-login";

const FaceBookLoginButton = ({ setAccessToken, autoLoad = false }: any) => {
  return (
    <FacebookLogin
      className="facebook-button active"
      appId="368961369584355"
      autoLoad={autoLoad}
      onSuccess={(response) => {
        console.log("Login Success!", response);
        setAccessToken(response?.accessToken);
      }}
      onFail={(error) => {
        console.log("Login Failed!", error);
      }}
      onProfileSuccess={(response) => {
        console.log("Profile Data:", response);
      }}
    />
  );
};

export default FaceBookLoginButton;
